@if (isEntityCreation()) {
  {{ entityName() }} "{{ attributeName() }}" <span class="text-sm text-(color:--text-secondary)">({{ createdText() }})</span>
} @else {
  {{ entityName() }} "{{ attributeName() }}" :
  <ces-value-change [detail]="detail()" />
}
